import {Injectable} from '@angular/core';
import {Graphql} from './graphql';
import {PopDto} from '../dto/pop-dto';
import {PopStatusSummaryDto} from '../dto/pop-status-summary-dto';

import {
  approvePop,
  createPop,
  removePop,
  retrieveActivePopByEmployeeId,
  retrievePopById,
  retrievePopsByUserId,
  retrievePopStatusSummary,
  updatePop,
  submitPopFeedbackRequest,
  updatePopFeedbackExpiryDate,
  createPopFeedback,
  retrievePopFeedback,
  retrieveAllPopsByUserId
} from '../graphql/pop.graphql';
import {PopFeedbackDto} from "../dto/pop-feedback-dto";

@Injectable({
  providedIn: 'root'
})
export class Pop extends Graphql {

  public retrievePopById(id: string, fields: string[] = ['id']) {
    return this.query<PopDto>(retrievePopById(fields), {id: id}, "retrievePopById");
  }

  public retrievePopsByUserId(userId: string, page: number, size: number, fields: string[] = ['id']) {
    return this.query<PopDto[]>(retrievePopsByUserId(fields), {
      employeeId: userId,
      page: page,
      size: size
    }, "retrievePopsByEmployeeId");
  }

  public retrieveAllPopsByUserId(userId: string, fields: string[] = ['id']) {
    return this.query<PopDto[]>(retrieveAllPopsByUserId(fields), {
      employeeId: userId,
    }, "retrieveAllPopsByEmployeeId");
  }

  public createPop(pop: PopDto, fields: string[] = ['id']) {
    return this.mutation<PopDto>(createPop(fields), {pop: pop}, "createPop");
  }

  public updatePop(pop: PopDto, fields: string[] = ['id']) {
    return this.mutation<PopDto>(updatePop(fields), {pop: pop}, "updatePop");
  }

  public removePop(popId: string) {
    return this.mutation<boolean>(removePop(), {popId: popId}, "removePop")
  }

  public retrievePopFeedback(popId: string, fields: string[] = ['id']) {
    return this.query<PopFeedbackDto>(retrievePopFeedback(fields), {popId: popId}, "retrievePopFeedback")
  }

  public createPopFeedback(popId: string, popFeedback: PopFeedbackDto, fields: string[] = ['id']) {
    return this.mutation<PopFeedbackDto>(createPopFeedback(fields), {popId: popId, popFeedback: popFeedback}, "createPopFeedback")
  }

  public retrieveActivePopByEmployeeId(employeeId: string, fields: string[] = ['id']) {
    return this.query<PopDto>(retrieveActivePopByEmployeeId(fields), {employeeId: employeeId}, "retrieveActivePopByEmployeeId");
  }

  public approvePop(popId: string) {
    return this.mutation<boolean>(approvePop(), {popId: popId}, "approvePop")
  }

  public retrievePopStatusSummary(fields: string[] = ['totalEmployees', 'completed', 'open']) {
    return this.query<PopStatusSummaryDto>(
      retrievePopStatusSummary(fields),
      {},
      'retrievePopStatusSummary'
    );
  }

  public submitPopFeedbackRequest(popId: string, feedbacks: PopFeedbackDto[], feedbackExpiryDate: string) {
    return this.mutation<boolean>(submitPopFeedbackRequest(), {popId: popId, feedbacks: feedbacks, feedbackExpiryDate: feedbackExpiryDate}, "submitPopFeedbackRequest")
  }

  public updatePopFeedbackExpiryDate(popId: string, feedbackExpiryDate: string, isSelfReflection: boolean) {
    return this.mutation<boolean>(updatePopFeedbackExpiryDate(), {popId: popId, feedbackExpiryDate: feedbackExpiryDate, isSelfReflection: isSelfReflection}, "updatePopFeedbackExpiryDate")
  }
}
